import React, { createContext, useContext, useEffect, useState } from "react";

const KEY = "ritzyra_completed_lessons";
const ProgressContext = createContext(null);

export function ProgressProvider({ children }) {
  const [done, setDone] = useState({});

  useEffect(() => {
    try {
      const ids = JSON.parse(localStorage.getItem(KEY) || "[]");
      const map = {};
      ids.forEach((id) => (map[id] = true));
      setDone(map);
    } catch {
      /* ignore */
    }
  }, []);

  const persist = (map) => {
    const ids = Object.keys(map).filter((k) => map[k]);
    localStorage.setItem(KEY, JSON.stringify(ids));
  };

  const value = {
    isDone: (id) => !!done[id],
    toggle: (id) =>
      setDone((prev) => {
        const next = { ...prev, [id]: !prev[id] };
        persist(next);
        return next;
      }),
    countDone: (ids) => ids.filter((id) => done[id]).length,
  };

  return <ProgressContext.Provider value={value}>{children}</ProgressContext.Provider>;
}

export function useProgress() {
  const ctx = useContext(ProgressContext);
  if (!ctx) throw new Error("useProgress must be used inside ProgressProvider");
  return ctx;
}
